import React from "react";
import { ReactComponent as NotFoundError } from "../../../_v2/assets/images/mercurio_error_404.svg";
import { MessagePageStruct } from "../";

const Error404 = () => {
  return (
    <>
      <MessagePageStruct
        image={
          <NotFoundError
            style={{
              height: "300px",
              width: "100%",
            }}
          />
        }
        title="Esta página no existe o fue eliminada"
        text="Revisa el enlace o intenta con otro. Si buscas un ítem específico, utiliza los filtros de cada sección."
      />
    </>
  );
};

export default Error404;
